export const ZENDESK_HELP_CENTER_URL = 'https://help.manychat.com'
